import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContractItem } from '@core/models/contract-item.model';
import { BaseService } from '@core/services/base/base.service';
import { ErrorHandlerService, HttpError } from '@core/services/error-handler.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContractCgvModelUpdateService extends BaseService {
  protected contractCgvModelUpdateRoute = environment.contract_microservice_api_base_url + '/contract-cgv-model-update/by-contract/';

  constructor(private httpService: HttpClient, private errorHandlerService: ErrorHandlerService) {
    super();
  }

  public updateContractCgvModel(contractItemId, contractItem: ContractItem): Observable<any> {
    const filter = {};

    const httpErrors: HttpError[] = [
      {
        statusCode: 404,
        message: 'Impossible de mettre à jour la liste des commitments. Veuillez essayer plus tard.',
      },
      {
        statusCode: 500,
        message: 'Une erreur est survenue. Veuillez essayer plus tard.',
      },
    ];

    const url = this.contractCgvModelUpdateRoute + contractItemId + this.getParamsFromFilter(filter);

    return new Observable(observer => {
      this.httpService.put(url, { contractItem: contractItem }).subscribe(
        (response: any) => {
          observer.next(response);
          observer.complete();
        },
        error => {
          this.errorHandlerService.showErrorMessage(httpErrors, error.status);
          observer.error(error);
          observer.complete();
        }
      );
    });
  }
}
